/** 与后端 hasPerm 一致：企业管理员、平台管理员看得到页面上已有的按钮。 */
export function checkAuth(user, permCodes, perm) {
  const current = user || {}
  const codes = Array.isArray(current.roleCodes) ? current.roleCodes : []
  const role = String(current.roleCode || '')
  if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) {
    return true
  }
  return (permCodes || []).indexOf(perm) >= 0
}
